import React, { useContext, useState } from "react";
import OTPInput from "../../../components/Otp/OTPInput";
import changePassword from "../../../assets/changePassword.svg";
import { useMutation, useQuery } from "@apollo/client";
import {
  SEND_CHANGE_PASS_OTP,
  GET_USER,
  VERIFY_PASSWORD_OTP,
} from "../../../Qurries";
import { toast } from "react-toastify";
import ProfileNav from "../Profile/ProfileNav";
import { dashboardContext } from "../Dashboard";

const ChangePassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const { isRedirectedUser, tokenData } = useContext(dashboardContext);

  const [sendOtp, { loading, error }] = useMutation(SEND_CHANGE_PASS_OTP);
  const [verifyPasswordOtp] = useMutation(VERIFY_PASSWORD_OTP, {
    errorPolicy: "ignore",
  });
  const { data: user_data } = useQuery(GET_USER);

  const [passwordVisible, setPasswordVisible] = useState(false);

  return (
    <div className="p-[25px] min-h-screen">
      <div className="bg-[#F6F8FA] w-[100%] h-[100%] p-[40px] rounded-[6px]">
        <h2 className="text-edviron_black font-bold">My Account</h2>
        <div className="flex flex-col lg:!flex-row h-[100%] pt-[40px]">
          {/* <div className="flex flex-col border-r-[0.5px] border-r-[rgb(224 226 229)] h-[100%] pr-[30px] w-[200px]">
                        <Link to="/profile"><p className="text-[#717171] text-[14px] mb-[10px]">Profile</p></Link>
                        <Link to="/team-members"><p className="text-[#717171] text-[14px] mb-[10px]">Team Members</p></Link>
                        <Link to="/change-password"><p className="text-[#717171] text-[14px]">Change Password</p></Link>
                    </div> */}
          <ProfileNav user={ isRedirectedUser ? tokenData?.role : user_data?.getMerchantQuery?.role} />
          <div className="flex-1 lg:pr-[20px] lg:mt-0 mt-4 lg:pl-[50px] flex">
            <div className="lg:!w-[50%] w-full">
              <div className="relative w-full">
                <input
                  type={passwordVisible ? "text" : "password"}
                  id="floating_outlined-1"
                  className="bg-[#F6F8FA] block px-4 py-1.5 h-[48px] w-full text-sm text-gray-900 border-[1.5px] border-[#B8C0CD] rounded-[6px] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-[#6687FF] peer"
                  placeholder=" "
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <label
                  htmlFor="floating_outlined-1"
                  className="bg-[#F6F8FA] absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                >
                  New Password
                </label>
                <div className="absolute right-[8px] top-[12px]">
                  {passwordVisible ? (
                    <i
                      onClick={() => setPasswordVisible(false)}
                      className="fa-solid fa-eye-slash cursor-pointer"
                    ></i>
                  ) : (
                    <i
                      onClick={() => setPasswordVisible(true)}
                      className="fa-solid fa-eye cursor-pointer"
                    ></i>
                  )}
                </div>
              </div>

              <div className="relative w-full mt-[20px]">
                <input
                  type="text"
                  id="floating_outlined-2"
                  className="block px-4 py-1.5 h-[48px] w-full text-sm text-gray-900 bg-transparent border-[1.5px] border-[#B8C0CD] rounded-[6px] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-[#6687FF] peer"
                  placeholder=" "
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <label
                  htmlFor="floating_outlined-2"
                  className="bg-[#F6F8FA] absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                >
                  Confirm New Password
                </label>
              </div>

              <button
                className="rounded-[6px] text-white px-[15px] text-[14px] py-[8px] bg-[#6687FF] mt-[40px]"
                onClick={async () => {
                  if (password === "") {
                    toast.error("Password cannot be empty");
                    return;
                  }
                  if (password !== confirmPassword) {
                    toast.error("Password does not match");
                    return;
                  }
                  try {
                    const res = await sendOtp({
                      variables: { type: "reset" },
                    });
                    if (res?.data?.sendMerchantResetPassOtp) {
                      toast.success("OTP send successfully");
                      setShowOtp(true);
                    }
                  } catch (err) {
                    console.log(err);
                  }
                }}
              >
                Change Password
              </button>

              {showOtp && (
                <>
                  <p className="mt-[30px] text-[14px] font-[400] text-[#1B163B]">
                    OTP has been sent to your registered email
                  </p>
                  <p className="text-[14px] font-[400] text-[#1B163B] mb-[30px]">
                    {user_data?.getMerchantQuery.email_id}
                  </p>

                  <OTPInput
                    length={6}
                    onComplete={async (otp: any) => {
                      if (password === "") {
                        toast.error("Password cannot be empty");
                        return;
                      }
                      if (otp === "") {
                        toast.error("OTP cannot be empty");
                        return;
                      }
                      if (password !== confirmPassword) {
                        toast.error("Password does not match");
                        return;
                      }
                      const res = await verifyPasswordOtp({
                        variables: { otp, password },
                      });
                      if (res.data?.verifyMerchantPasswordOtp) {
                        toast.success(res.data?.verifyMerchantPasswordOtp);
                        setShowOtp(false);
                        setPassword("");
                        setConfirmPassword("");
                      }
                    }}
                    reSend={async () => {
                      return await sendOtp({
                        variables: { type: "reset" },
                      });
                    }}
                    btnText={"Confirm"}
                    cancel={() => {
                      setPassword("");
                      setConfirmPassword("");
                      setShowOtp(false);
                    }}
                  />
                </>
              )}
            </div>
            <div className="w-[50%] lg:flex hidden items-center justify-center">
              <img
                src={changePassword}
                alt=""
                className="w-[379.52px] h-[379.52px]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
